<template>
  <a-tabs
      v-model:activeKey="searchForm.type"
      style="background-color: #fff; padding: 0 12px"
      @change="getTableData()"
  >
    <a-tab-pane key="1" tab="收入"></a-tab-pane>
    <a-tab-pane key="2" tab="支出"></a-tab-pane>
  </a-tabs>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-select
                v-model:value="searchForm.date_type"
                allowClear
                placeholder="日期类型"
                @change="getTableData"
            >
              <a-select-option :value="1">记账日期</a-select-option>
              <a-select-option :value="2">结算日期</a-select-option>
              <a-select-option :value="3">创建日期</a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.year"
                placeholder="年份"
                @change="getTableData"
            >
              <a-select-option :value="dayjs().year()">{{
                  dayjs().year()
                }}
              </a-select-option>
              <a-select-option
                  v-for="(item, index) in 4"
                  :key="index"
                  :value="dayjs().year() - item"
              >{{ dayjs().year() - item }}
              </a-select-option
              >
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.rids"
                :dropdownMatchSelectWidth="false"
                :filterOption="roomFilter"
                :max-tag-count="2"
                mode="multiple"
                placeholder="房型"
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.room.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.gids"
                :dropdownMatchSelectWidth="false"
                :filterOption="groupFilter"
                :maxTagCount="1"
                mode="multiple"
                placeholder="分组"
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.group.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.is_verify"
                allowClear
                placeholder="是否确认"
                @change="getTableData"
            >
              <a-select-option :value="1">已确认</a-select-option>
              <a-select-option :value="2">待确认</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.hname"
              :loading="searchLoading"
              placeholder="请输入房间名称"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-button>
            <upload-outlined/>
            导出
          </a-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        bordered
        class="table"
        size="small"
    >
    </a-table>
  </div>
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";
import {costStructure, getSearchList} from "@/api/api";
import dayjs from "dayjs";
import {UploadOutlined} from "@ant-design/icons-vue";

export default {
  components: {
    UploadOutlined,
  },
  setup() {
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        type: 1,
        year: dayjs().year(),
        hname: "",
        rids: [],
        gids: [],
        date_type: 1,
        is_verify: [],
      },
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      getSearchData() {
        if (!search.searchList.length) {
          getSearchList().then((res) => {
            search.searchList = res.data;
          });
        }
      },
      handleReset() {
        search.searchForm.hname = "";
        search.searchForm.year = dayjs().year();
        search.searchForm.gids = [];
        search.searchForm.rids = [];
        search.searchForm.date_type = 1;
        search.searchForm.is_verify = [];
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      countDate: {},
      columns: [
        {
          title: "项目",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 100,
          fixed: "left",
        },
        {
          title: "1月",
          dataIndex: "01",
          key: "01",
          align: "center",
          width: 100,
        },
        {
          title: "2月",
          dataIndex: "02",
          key: "03",
          align: "center",
          width: 100,
        },
        {
          title: "3月",
          dataIndex: "03",
          key: "03",
          align: "center",
          width: 100,
        },
        {
          title: "4月",
          dataIndex: "04",
          key: "04",
          align: "center",
          width: 100,
        },
        {
          title: "5月",
          dataIndex: "05",
          key: "05",
          align: "center",
          width: 100,
        },
        {
          title: "6月",
          dataIndex: "06",
          key: "06",
          align: "center",
          width: 100,
        },
        {
          title: "7月",
          dataIndex: "07",
          key: "07",
          align: "center",
          width: 100,
        },
        {
          title: "8月",
          dataIndex: "08",
          key: "08",
          align: "center",
          width: 100,
        },
        {
          title: "9月",
          dataIndex: "09",
          key: "09",
          align: "center",
          width: 100,
        },
        {
          title: "10月",
          dataIndex: "10",
          key: "10",
          align: "center",
          width: 100,
        },
        {
          title: "11月",
          dataIndex: "11",
          key: "11",
          align: "center",
          width: 100,
        },
        {
          title: "12月",
          dataIndex: "12",
          key: "12",
          align: "center",
          width: 100,
        },
      ],
      getTableData() {
        search.searchLoading = true;
        costStructure({
          year: search.searchForm.year,
          type: search.searchForm.type,
          hname: search.searchForm.hname,
          rids: search.searchForm.rids.toString(),
          gids: search.searchForm.gids.toString(),
          date_type: search.searchForm.date_type,
          is_verify: search.searchForm.is_verify,
        })
            .then((res) => {
              table.dataSource = [];
              for (let i = 0; i < res.data.list.length; i++) {
                let obj = {};
                for (let item of res.data.list[i]) {
                  obj[item.month] = item.money;
                }
                table.dataSource.push(Object.assign(obj, res.data.left[i]));
              }
              let total = {};
              for (let items of res.data.top) {
                total[items.name.replace("月", "")] = items.total;
              }
              total.name = "总计";
              table.dataSource.unshift(total);
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
    });

    onMounted(() => {
      search.getSearchData();
      table.getTableData();
    });

    return {
      dayjs,
      ...toRefs(search),
      ...toRefs(table),
    };
  },
};
</script>

<style lang="scss" scoped>
.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.count {
  display: flex;
  justify-content: center;
  margin: 10px;

  .bar {
    margin: 0 40px;
  }

  .text {
    margin-left: 5px;
  }
}
</style>
